import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from '@wit-support/ui';
import { cn } from './lib/cn.js';
/**
 * Shared shell for the conversation right rail: an icon + uppercase title
 * header row followed by arbitrary body content. Extracted from 10
 * byte-identical copies across `inbox-page.tsx`, `queue-panel.tsx`, and
 * `identity-search-panel.tsx` (kit-extraction Wave 6, task 5). The
 * `inbox-page.tsx` and `queue-panel.tsx` copies migrated onto this component
 * in Wave 7/8 (now the `rail/*.tsx` panels + `queue-panel.tsx`);
 * `identity-search-panel.tsx` still owns its own plain `Card` wrapper as of
 * this writing.
 */
export function RailCard({ icon: Icon, title, headerExtra, children, className }) {
    return (_jsxs(Card, { className: cn('flex flex-col gap-2 px-3 py-2.5 text-sm', className), children: [_jsxs("div", { className: "flex items-center gap-1.5 text-[var(--color-text-muted)]", children: [_jsx(Icon, { className: "h-4 w-4" }), _jsx("span", { className: "text-xs font-medium uppercase tracking-wide", children: title }), headerExtra] }), children] }));
}
//# sourceMappingURL=rail-card.js.map